import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const star = {
  fetchStarCity: lazyModuleMethod(() => import('./fetchStarCity'), 'default'),
  fetchStarFamilyStatus: lazyModuleMethod(
    () => import('./fetchStarFamilyStatus'),
    'default'
  ),
  fetchStarOccupation: lazyModuleMethod(
    () => import('./fetchStarOccupation'),
    'default'
  ),
  fetchStarState: lazyModuleMethod(() => import('./fetchStarState'), 'default'),
  createStarWorksSingle: lazyModuleMethod(
    () => import('./createStarWorksSingle'),
    'default'
  ),
  createStarWorksMass: lazyModuleMethod(
    () => import('./createStarWorksMass'),
    'default'
  ),
  changeStarWorks: lazyModuleMethod(
    () => import('./changeStarWorks'),
    'default'
  ),
  deleteStarWorks: lazyModuleMethod(
    () => import('./deleteStarWorks'),
    'default'
  ),
  createBiography: lazyModuleMethod(
    () => import('./createBiography'),
    'default'
  ),
  fetchStars: lazyModuleMethod(() => import('./fetchStars'), 'default'),
  createStar: lazyModuleMethod(() => import('./createStar'), 'default'),
}
